import { CMLUtils } from '@coursera-web/cml';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'vend... Remove this comment to see the full error message
import createStore from 'vendor/cnpm/fluxible.v0-4/addons/createStore';

import AuthoringState from 'bundles/author-common/constants/AuthoringState';

const GroupAnnouncementStore = createStore({
  storeName: 'GroupAnnouncementStore',

  initialize() {
    this.reset();
  },

  getDraftId() {
    return this.emailResponse ? this.emailResponse.id.toString() : '';
  },

  getPartnerId() {
    return this.partnerId;
  },

  getEditMode() {
    return this.editMode;
  },

  getEmailResponse() {
    return this.emailResponse;
  },

  getEmailPreview(emailId: $TSFixMe) {
    return this.emailPreviews[emailId];
  },

  getEmailPreviews() {
    return this.emailPreviews;
  },

  getEmailId() {
    return this.emailResponse && this.emailResponse.id;
  },

  getCurrentResponseId() {
    return this.currentResponseId || (this.emailResponse && this.emailResponse.id);
  },

  getCanPreview() {
    return !this.subjectEmpty && !this.bodyEmpty;
  },

  getSaveState() {
    return this.saveState;
  },

  getSentEmails() {
    return this.sentEmails;
  },

  getEmailLimitReached() {
    return this.emailLimitReached;
  },

  validate() {
    if (this.emailResponse) {
      const emailDefinition = this.emailResponse.message.definition;

      this.subjectEmpty = emailDefinition.payload.subject === '';
      this.bodyEmpty = CMLUtils.isEmpty(emailDefinition.payload.content);
    }
  },

  reset() {
    this.emailResponse = null;
    this.emailPreviews = {};
    this.editMode = true;
    this.saveState = AuthoringState.Idle;
    this.sentEmails = [];

    this.subjectEmpty = true;
    this.bodyEmpty = true;
    this.emailLimitReached = false;
    this.currentResponseId = null;
  },
});

GroupAnnouncementStore.handlers = {
  RECEIVED_EMAIL({ emailResponse }: $TSFixMe) {
    this.emailResponse = emailResponse;
    this.validate();
    this.emitChange();
  },

  RECEIVED_UPDATED_METADATA({ newEmailResponse }: $TSFixMe) {
    this.emailResponse.metadata = newEmailResponse.metadata;
    this.saveState = AuthoringState.Idle;
    this.emitChange();
  },

  RECEIVED_EMAIL_PREVIEW({ emailResponse, html }: $TSFixMe) {
    this.emailPreviews[emailResponse.id] = html;
    this.emitChange();
  },

  RECEIVED_EMAIL_HISTORY({ emailHistory }: $TSFixMe) {
    this.sentEmails = emailHistory;
    this.emitChange();
  },

  EDIT() {
    this.editMode = true;
    this.emitChange();
  },

  PREVIEW() {
    this.editMode = false;
    this.emailPreviews[this.getEmailId()] = '';
    this.emitChange();
  },

  SHOW_SAVE_NOTIFICATION() {
    if (this.saveState.id !== AuthoringState.InProgress.id) {
      this.saveState = AuthoringState.InProgress;
      this.emitChange();
    }
  },

  UPDATE_SUBJECT({ subject }: $TSFixMe) {
    this.emailResponse.message.definition.payload.subject = subject;
    this.saveState = AuthoringState.InProgress;
    this.validate();
    this.emitChange();
  },

  UPDATE_BODY({ cmlObject }: $TSFixMe) {
    this.emailResponse.message.definition.payload.content.definition = cmlObject.definition;
    this.saveState = AuthoringState.InProgress;
    this.validate();
    this.emitChange();
  },

  UPDATE_CURRENT_RESPONSE_ID({ responseId }: $TSFixMe) {
    this.currentResponseId = responseId;
    this.emitChange();
  },

  PUBLISH() {
    this.saveState = AuthoringState.PublishInProgress;
    this.emitChange();
  },

  PUBLISHED() {
    this.saveState = AuthoringState.Published;
    this.emitChange();
  },

  CONFLICT() {
    this.saveState = AuthoringState.Conflict;
    this.emitChange();
  },

  ERROR() {
    this.saveState = AuthoringState.Error;
    this.emitChange();
  },

  EMAIL_LIMIT() {
    this.emailLimitReached = true;
    this.emitChange();
  },

  SOFT_RESET() {
    this.saveState = AuthoringState.Idle;
    this.emailResponse = null;
    this.editMode = true;
  },
};

export default GroupAnnouncementStore;
